import { Injectable } from '@angular/core';

@Injectable()
export class InvoiceInfo {
  userId?: number;
  invoicePriceHtc?: string;
  invoicePaymentReference?: string;
  invoiceOrderCode?: string;
  invoicePaymentStatus?: string;
  invoicePriceTtc?: string;
  invoicePriceVat?: string;
  priceId?: number;   
  vatPercent?: string;
  reprogId?: number;
  type?: string;
  modLanguage?: string;
  assitanceTokenPurchasedQuantity?: number;
  assistanceOfferId?: number;
  userIds?: any;
  countryCode?: string;
  adtSubscriptionOfferId?: number;
  clipSubscriptionOfferId?: number;
  clipAdtSubscriptionOfferId?: number;
  parentId?: number;
  languageCode?: string;
}
